import { IMonitorServices } from './monitor.types'
import moment from 'moment';
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { i18n } from "@/plugins/i18n";

export class MonitorService implements IMonitorServices {

    /** list the financial reports */
    listFinancialReports(id: number): any {
        return http.get(`api/FinancialReport/Grant/${id}/List`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });

    }

    /** list the technical Reports */
    listTechnicalReports(id: number): any {
        return http.get(`api/TechnicalReport/Grant/${id}/List`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** list the communication Reports */
    listCommunicationReports(id: number): any {
        return http.get(`api/GrantCommunication/Grant/${id}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** Start the technical report */
    startTechnicalReport(id: number): any {
        return http.put(`api/TechnicalReport/${id}/Start`, {})
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }
    
    /** STart the financial report */
    startFinancialReport(id: number): any {
        return http.put(`api/FinancialReport/${id}/Start`, {})
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** get the technical report */
    getTechnicalReport(id: number): any {
        return http.get(`api/TechnicalReport/${id}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** get the financial report */
    getFinancialReport(id: number): any {
        return http.get(`api/FinancialReport/${id}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** update the financial report */
    updateFinancialReport(id: number, financialReport: any): any {
        return http.put(`api/FinancialReport/${id}`, financialReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** update the financial report */
    updateFinancialReportPeriod(id: number, financialReport: any): any {
        return http.put(`api/FinancialReport/${id}/UpdatePeriod`, financialReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    saveFinancialReport(id: number, financialReport: any, section: string): any {
        return http.put(`api/FinancialReport/${id}/data/${section}`, financialReport)
            .then((resp: any) => {
                if(resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            });
    }

    /** update the financial report */
    updateTechnicalReport(id: number, technicalReport: any): any {
        return http.put(`api/TechnicalReport/${id}`, technicalReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** update the financial report */
    updateTechnicalReportPeriod(id: number, technicalReport: any): any {
        return http.put(`api/TechnicalReport/${id}/UpdatePeriod`, technicalReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** update the financial report */
    saveFinalTechnicalReport(grantId: number, reportId: number, technicalReport: any): any {
        return http.put(`api/TechnicalReport/Grant/${grantId}/Report/${reportId}`, technicalReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    saveTechnicalReport(grantId: number, reportId: number, technicalReport: any): any {
        return http.put(`api/TechnicalReport/Grant/${grantId}/Report/${reportId}/data`, technicalReport)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    getGrantInformation(id: number, reportId: number): any {
        return http.get(`api/TechnicalReport/${id}/Report/${reportId}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    getGrantInfo(id: number): any {
        return http.get(`api/FinancialReport/${id}/data`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    getAppBudgetForGrant(id: number, financialReportId: number, period: string): any {
        return http.get(`api/FinancialReport/${id}/${financialReportId}/${period}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    getCurrency(): any {
        return http.get(`api/Common/GetCurrency`)
            .then((resp: any) => {
                if(resp.status >= 200 && resp.status <= 300) {
                    return resp.data.Record;
                }
            })
    }

    getTemplate(id: any): any {
        id = id || 0;
        return http.get(`api/FinancialReport/GetTemplate/${id}`)
            .then((resp: any) => {
                if(resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            });
    }
    importFile(file: any, transactionId: number,appId: number,type:string){
        console.log(file)
        let formData = new FormData();
        formData.append("file", file);
        return http.post(`api/FinancialReport/Import/${transactionId}/${appId}/${type}`, formData, 'multipart/form-data')
            .then((resp: any) => {
                if (resp.data.Result === 'OK') {
                    return resp.data
                }
                else{
                    return resp.data
                }
            });
    }
    downloadTemplate(reportId: any, grantId: any, filename: string) {
        /*const link = process.env.VUE_APP_API_Base_URL + `api/FinancialReport/Download/${id}`;
        window.open(link, "_self");*/
        http.getFile(`api/FinancialReport/Download/${grantId}/${reportId}`, 'application/vnd.ms-excel')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',`${filename || 'SOS Interim Financial Reporting Template'}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }
    exportReport(reportId:any, grantId:any, filename: string)
    {
        http.getFile(`api/FinancialReport/ExportReport/${reportId}/${grantId}`, 'application/vnd.ms-excel')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',`${filename || 'SOS Interim Financial Report'}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }
    /** transform to ES enitity type before save */
    transformAppData(datum: any) {

        let appData = utils.clone(datum);
        // #. series reserved  properties
        const reservedKeys = ['descr', 'activityCode', 'matchFunding', 'details',  'detail_expl'];
        appData.finReport.map((item: any) => {
            let budgetData: any = {};
            
    
            if (item.forecast && Object.keys(item.forecast).length > 0) {
    
                /** get the root properties */
                const { categories, series, data, summary } = item.forecast;
    
                budgetData.category = categories;
    
                budgetData.series = series;
    
                // #. trasform the data property as object array instead of object prop
                if (data && Object.keys(data).length > 0) {
    
                    budgetData.data_row = (Object.keys(data).reduce((result: any, key: string) => {
    
                        // #. loop through the line items
                        data[key].forEach((lineItem) => {
    
                            var obj = { "category_id": key };
    
                            obj["series_data"] = [];
    
                            // #. loop through the line item properties
                            Object.keys(lineItem).forEach((prop: string) => {
                                if (reservedKeys.includes(prop)) {
                                    obj[prop] = lineItem[prop];
                                } else {
                                    let seriesProp = { 'key': prop };
                                    Object.assign(seriesProp, lineItem[prop]);
                                    obj["series_data"].push(seriesProp);
                                }
                            });
    
                            result.push(obj);
                        });
    
                        return result;
                    }, []));
                } else {
    
                    budgetData.data_row = {};
                }
    
                /** parse the summary section */
                if (summary) {
                    budgetData.summary = {};
    
                    Object.keys(summary).forEach((summarykey) => {
                        if(summarykey === 'subtotals') {
    
                            budgetData.summary.subtotals = [];
    
                            Object.keys(summary.subtotals).forEach((catg) => {
    
                                // #. set the category id
                                let subTotal = { "category_id": catg };
    
                                subTotal["series_data"] = [];
    
                                /** loop through the props */
                                Object.keys(summary.subtotals[catg]).forEach((col) => {
                                    if (reservedKeys.includes(col)) {
                                        subTotal[col] = summary.subtotals[catg][col];
                                    } else {
                                        let seriesProp = { 'key': col };
                                        Object.assign(seriesProp, summary.subtotals[catg][col]);
                                        subTotal["series_data"].push(seriesProp);
                                    }
                                });
    
                                budgetData.summary.subtotals.push(subTotal);
                            });
                        } else {
                            /** summary line items */
                            budgetData.summary[summarykey] = [];
    
                            /** get the common properties of summary if any */
                            let commonProps = {};
    
                            Object.keys(summary[summarykey])
                            .filter(x => reservedKeys.includes(x))
                            .forEach((key) => {
                                budgetData.summary[key] = budgetData.summary[key] || [];
                                budgetData.summary[key].push({ 'item': summarykey, 'value': summary[summarykey][key] });
                            });                        
    
                            Object.keys(summary[summarykey])
                            .filter(x => !reservedKeys.includes(x))
                            .forEach((series) => {
                                budgetData.summary[summarykey].push( Object.assign( { series }, summary[summarykey][series]) );
                            });
                        }
                    })                
                }
            }

            item.forecast = budgetData;
            let reports = ["transactions", "personnelCost", "detailedExpenses", "detailedListing"];
            reports.forEach(report => {
                if (item[report]) {
                    //Remove added empty rows from each reports
                    item[report] = item[report].filter(entry => Object.keys(entry).length > 1);

                    //Remove document mapping if it does not exists in uploaded documents
                    item[report].forEach(obj => {
                        const isValidDoc = item.finReportDocuments.some(doc => doc.name === obj.mappedFileName);
                        if (!isValidDoc) {
                            obj.mappedFileName = null;
                        }
                    });
                }
            });
        });
        
        return appData;
    }

    mergeBudgetSummary(datum: any, summary: any, reportId: number)
    {
        if(datum && datum.finReport){
            var currentReport = datum.finReport.find(x => x.FinancialReportId === reportId);
            if(currentReport) {
                if(!currentReport.budgetSummary) {
                    currentReport.budgetSummary = [];
                }

                if(summary){
                    Object.keys(summary.data).forEach((categoryId) => {
                        var lineItems = summary.data[categoryId];
                        lineItems.forEach((_lineitem) => {
                            var summary = currentReport.budgetSummary.find(x => x.budgetCategory == categoryId && x.budgetLine == _lineitem.descr);
                            if(summary) {
                                summary.variationExplanation = _lineitem.variationExplanation;
                            } else {
                                currentReport.budgetSummary.push({
                                    budgetCategory: categoryId,
                                    budgetLine: _lineitem.descr,
                                    variationExplanation: _lineitem.variationExplanation
                                });
                            }
                        })
                    })
                }
            }
        }

        return datum;
    }

    /** transform to schema form compatible type */
    transformForecastEntity(data: any, schema: any, isRAG: boolean ) {

        // #. series reserved  properties
        const reservedKeys = ['descr', 'activityCode', 'details', 'matchFunding', 'detail_expl'];
        // if(!data.finReport) {
        //     data.finReport = {};
        // }
        
        if (schema && schema.properties && data.finReport.length > 0) {
            let budgetTemplate: any = schema;

            data.finReport.map((item: any) => {
                let budgetData: any = {};
                item.forecast = item.forecast || {};
                if (item.forecast) {
    
                    // #. assign categories, fill from schema if not exists
                    if (item.forecast.category) {
                        budgetData.categories = item.forecast.category;
                    } else {
                        budgetData.categories = budgetTemplate.properties.categories.default;
                        // Reset the existing entries
                        item.forecast.data_row = [];
                        item.forecast.summary = {};
                    }
    
                    // #. assign series 
                    if (item.forecast.series && item.forecast.series.length === budgetTemplate.properties.series.default.length ) {
                        budgetData.series = item.forecast.series;
                    } else {
                        // default values
                        // TO DO: Get from the schema if not exists
                        budgetData.series = budgetTemplate.properties.series.default;
                        // Reset the existing entries
                        item.forecast.data_row = [];
                        item.forecast.summary = {};
                    }
    
                    // if RAG show only Total
                    if(isRAG && budgetTemplate['x-budgetType'] !== 'tiger' && budgetData.series.length > 1){
                        budgetData.series = [ budgetData.series[0] ];
                    }
    
                    const { data_row, summary } = item.forecast;
    
                    // #. parse the data rows
                    if (data_row && data_row.length > 0) {
    
                        // #. make it key value properties from array of props
                        budgetData.data = data_row.reduce((result, lineItem) => {
    
                            const key = lineItem["category_id"];
    
                            if (!result[key]) {
                                result[key] = [];
                            }
    
                            // #. parse the series column
                            const row = Object.keys(lineItem).reduce((out, item) => {
    
                                if (item === 'series_data') {
                                    lineItem['series_data'].forEach((series) => {
                                        out[series.key] = series;
                                        delete series.key;
                                    })
                                } else if (reservedKeys.includes(item)) {
                                    out[item] = lineItem[item]
                                }
                                return out;
                            }, {});
    
                            // check and fill the missing series..
                            budgetData.series.forEach((series) => {
                                if(!row[series.name]) {
                                    row[series.name] = {};
                                }
                            });
    
                            result[key].push(row);
    
                            return result;
    
                        }, {});
                    } else {
                        budgetData.data = {};
                    }
    
                    /** add default value for the missing categories */
                    budgetData.categories.forEach((catg) => {
                        if(!budgetData.data[catg.id]) {
                            budgetData.data[catg.id] = [];
                        }
                    });
    
                    /*** summary section */
                    budgetData.summary = {};
    
                    if(budgetTemplate['x-subtotals']) {
                        budgetData.summary.subtotals = {};
    
                        if(summary && summary.subtotals && summary.subtotals.length > 0 ) {
    
                            // #. get the sub total line items
                            summary.subtotals.forEach((subtotal) => {
    
                                let subTotalProp = {};
    
                                Object.keys(subtotal).forEach((key) => {
                                    if(key === 'series_data') {
                                        subtotal[key].forEach((total) => {
                                            subTotalProp[total.key] = total;
                                        });
                                    } else {
                                        subTotalProp[key] = subtotal[key];
                                    }
                                });
                                // check and fill the missing series..
                                budgetData.series.forEach((series) => {
                                    if(!subTotalProp[series.name]) {
                                        subTotalProp[series.name] = {};
                                    }
                                });
    
                                budgetData.summary.subtotals[subtotal["category_id"]] = subTotalProp;
                            })
                        } else {
                            // #. set default value if not exists
                            budgetData.summary.subtotals = budgetData.categories.reduce((obj, item) => {
                                if(!obj[item.id]){
    
                                    obj[item.id] = {};
                                    obj[item.id]['descr'] = `${i18n.t('Sub Total')}`;
    
                                    budgetData.series.forEach((series) => {
                                        obj[item.id][series.name] = {};
                                    });
                                }
                                return obj;
                            }, {});
                        }
    
                        // #. get the budget data properties
                        Object.keys(budgetTemplate.properties.summary.properties).forEach((summaryKey) => {
                            budgetData.summary[summaryKey] = {};
                            if(summary && summary[summaryKey] && summary[summaryKey].length > 0) {
                                summary[summaryKey].forEach((item) => {
                                    budgetData.summary[summaryKey][item.series] = item;
                                    delete budgetData.summary[summaryKey][item.series].series;
                                });
                            } else {
                                budgetData.series.forEach((series) => {
                                    budgetData.summary[summaryKey][series.name] = {};
                                });
                            }                        
                        });
    
                        if(summary) {
                            /** update the non series columns */
                            Object.keys(summary)
                            .filter(x => reservedKeys.includes(x))
                            .forEach((x) => {
                                summary[x].forEach((info) => {
                                    budgetData.summary[info.item][x] = info.value;
                                });
                            });
                        }
                    }
                }
                item.forecast = budgetData;
            });

        }
        return data;
    }

    copyPerformanceReportData(data: any) {
        let appData = utils.clone(data), completedResultIds = [], others = [];

        if (appData.techReport) {
            appData.techReport.map((report: any) => {
                if (report.performanceReport) {
                    report.performanceReport.map((row: any) => {
                        if (row.progress && row.progress === 1) {
                            completedResultIds.push(row.id);
                        } else if (row.progress && row.progress !== 1) {
                            others.push({
                                id: row.id,
                                progress: row.progress
                            });
                        }
                    });

                    report.performanceReport.map((item: any) => {
                        if (completedResultIds.includes(item.id)) {
                            item.completed = true;
                            item.progress = 1;
                        } else {
                            others.map((x: any) => {
                                if (x.id === item.id) {
                                    item.progress = x.progress;
                                }
                            });
                        }
                    });
                }
            });
        }

        return appData;
    }

    requestSamples(data: any, id: number, section: string): any {
        return http.post(`api/FinancialReport/${id}/${section}/audit`, data)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                return null;
            }
        });
    }

    saveRequestedDoc(auditDocs: any): any {
        return http.put(`api/FinancialReport/audit`, auditDocs)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                return null;
            }
        });
    }
}